import { z } from 'zod';

import { QuestionDifficultyEnum } from '../../enums';

export const GenerateShortAnswerFromTextSchema = z.object({
  difficulty: z
    .nativeEnum(QuestionDifficultyEnum)
    .optional()
    .describe('Optional difficulty level for the generated question'),
  text: z
    .string()
    .min(1, 'Text content cannot be empty.')
    .describe('Text content to generate question from'),
});

export type IGenerateShortAnswerFromTextDto = z.infer<
  typeof GenerateShortAnswerFromTextSchema
>;
